<template>
  <div class="admin-inputfield position-relative">
    <label class="fs-14 font-mont fw-500 color-darkblack"
      ><span v-if="!noLabel">{{ label }}</span
      ><span v-show="isMandatory" class="asterik">*</span></label
    >
    <b-form-input
      :placeholder="placeholder"
      :type="type || 'text'"
      :class="{ 'mt-2': noLabel, error: error }"
      v-model="localValue"
      :disabled="disabled"
      @input="handleInput"
      @keydown="restrictInput"
      @keyup.enter="onEnter"
      @keyup="onKeyUp"
    ></b-form-input>
    <img
      v-if="addButton"
      @click="onEnter"
      class="tags-add-icon pointer"
      src="../../assets/images/paneldetails/blueRoundAdd.svg"
      alt=""
    />
  </div>
</template>
<script>
export default {
  name: "InputField",
  props: {
    label: {
      type: String,
      default: "Label",
    },
    isMandatory: {
      type: Boolean,
      default: true,
    },
    noLabel: {
      type: Boolean,
    },
    vmodel: {
      type: [String, Number],
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "",
    },
    addButton: {
      type: Boolean,
      default: false,
    },
     placeholder: {
      type: String,
      default: "Enter",
     },
    fixedTo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localValue: "",
    };
  },
  watch: {
    localValue(newValue) {
      this.$emit("update-value", newValue);
    },
    vmodel(newValue) {
      this.localValue = newValue;
    },
  },
  created(){
    if(this.vmodel){
      this.localValue=this.vmodel
    }
  },
  methods: {
    onEnter() {
      this.$emit("update-on-enter");
    },
    onKeyUp() {
      this.$emit("update-on-keyup");
    },
    restrictInput(event) {
      if (this.type === "numeric") {
        const charCode = event.key;

        // Allow Tab key to work as normal for navigation
        if (charCode === "Tab") {
          return;
        }

        // Allow copy-paste operations (Ctrl + A, C, V, X) for convenience
        if (event.ctrlKey || event.metaKey) {
          if (
            charCode === "a" ||
            charCode === "c" ||
            charCode === "v" ||
            charCode === "x"
          ) {
            return;
          }
        }

        // Allow backspace, arrow keys, and delete keys for normal editing behavior
        if (
          charCode === "Backspace" ||
          charCode === "ArrowLeft" ||
          charCode === "ArrowRight" ||
          charCode === "Delete"
        ) {
          return;
        }

        // Block all special characters (e.g., +, -, e, ., etc.)
        if (/[^\d]/.test(charCode)) {
          event.preventDefault();
          return;
        }

        if (this.fixedTo) {
          if (this.localValue.length >= 4) {
            event.preventDefault();
          }
        }
      }
    },
    handleInput(){
      const trimmedValue = this.localValue.trim();

  
  this.$emit('update-value', trimmedValue);
  this.$emit('select-value', trimmedValue);
    }
  },
};
</script>
<style>
.tags-add-icon {
  position: absolute;
  right: 10px;
  top: 40px;
}
</style>
